import { render, staticRenderFns } from "./DashboardAssignmentsDoc.vue?vue&type=template&id=76416dac"
import script from "./DashboardAssignmentsDoc.vue?vue&type=script&lang=js"
export * from "./DashboardAssignmentsDoc.vue?vue&type=script&lang=js"
import style0 from "./DashboardAssignmentsDoc.vue?vue&type=style&index=0&id=76416dac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports